/** Get the Elastic Search engine name for the provided site.
 * @param site The site name from SitecoreContext.
 * @example
 * const { sitecoreContext } = useSitecoreContext();
 * const engine = GetSearchEngineName(sitecoreContext.site.name);
 */
export function GetSearchEngineName(site?: string): string {
  const engine = site ? `${process.env.SEARCH_ENGINE_BASE}-${site?.toLowerCase()}` : '';
  return engine;
}

export function GetSearchSources(): { ui: string; config: string; css: string } {
  const searchUIDomain = process.env.SEARCH_UI_DOMAIN;
  const css = `${searchUIDomain}/style.css`;
  const config = `${searchUIDomain}/config.js`;
  const ui = `${searchUIDomain}/SearchUi.umd.js`;

  return { ui, config, css };
}
